









import { computed, defineComponent }  from '@vue/composition-api';
import cLoginHeader                   from '@/views/login/components/login-header/login-header.component.vue';
import cLoginCarousel                 from '@/views/login/components/login-carousel/login-carousel.component.vue';
import cLoginFormWrapper              from '@/views/login/components/login-form-wrapper/login-form-wrapper.component.vue';
import cLoginFooterCookie             from '@/views/login/components/login-footer-cookie/login-footer-cookie.component.vue';
import { GlobalContexts, useGlobals } from '@/hooks/use-globals';
import { Computed }                   from '@/types';
import { State }                      from '@/views/login/store/state.store';

export default defineComponent({
  name: 'vLogin',
  components: {
    cLoginHeader,
    cLoginCarousel,
    cLoginFormWrapper,
    cLoginFooterCookie,
  },
  setup() {
    const { store }: GlobalContexts = useGlobals();
    const isCookiePolicyAccepted: Computed<boolean> = computed(() => (store.state.views?.vLogin as State)?.cookieAccepted);

    return {
      isCookiePolicyAccepted,
    };
  },
});
